import api from './api';

/**
 * Service de vérification de documents
 * Gère la vérification d'authenticité et de validité des attestations
 */

export const verifyDocument = async (reference) => {
  try {
    if (!reference || !reference.trim()) {
      throw new Error('La référence du document est requise');
    }

    const response = await api.post('/souscriptions/verify-document', {
      reference: reference.trim().toUpperCase()
    });
    
    return {
      success: true,
      data: response.data
    };
    
  } catch (error) {
    console.error('Erreur lors de la vérification du document:', error);
    
    // Gestion des erreurs spécifiques
    let errorMessage = 'Erreur lors de la vérification du document';
    
    if (error.response) {
      // Erreur du serveur avec réponse
      if (error.response.status === 404) {
        errorMessage = 'Service de vérification non disponible';
      } else if (error.response.status === 400) {
        errorMessage = error.response.data?.detail || 'Référence invalide';
      } else if (error.response.status === 500) {
        errorMessage = 'Erreur interne du serveur';
      } else if (error.response.data?.detail) {
        errorMessage = error.response.data.detail;
      }
    } else if (error.request) {
      // Erreur réseau
      errorMessage = 'Impossible de contacter le serveur de vérification';
    } else if (error.message) {
      // Erreur de validation locale
      errorMessage = error.message;
    }
    
    return {
      success: false,
      error: errorMessage
    };
  }
};

/**
 * Valider le format d'une référence de document
 * @param {string} reference - La référence à valider
 * @returns {object} - Objet avec isValid et message
 */
export const validateReferenceFormat = (reference) => {
  if (!reference || !reference.trim()) {
    return {
      isValid: false,
      message: 'La référence est requise'
    };
  }

  const cleanRef = reference.trim().toUpperCase();
  
  // Format attendu: ATT-XXXXX (minimum 6 caractères après ATT-)
  const referenceRegex = /^ATT-[A-Z0-9]{6,}$/;
  
  if (!referenceRegex.test(cleanRef)) {
    return {
      isValid: false,
      message: 'Format invalide. Format attendu: ATT-XXXXXX (ex: ATT-D28B8C)'
    };
  }

  return {
    isValid: true,
    message: 'Format valide'
  };
};

/**
 * Formater une référence selon les standards
 * @param {string} reference - La référence brute
 * @returns {string} - Référence formatée
 */
export const formatReference = (reference) => {
  if (!reference) return '';
  
  return reference
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9-]/g, ''); // Supprimer caractères non autorisés
};